const routes = [
  {
    path: 'datepicker',
    name: 'datepicker',
    component: () => import(/* webpackChunkName: "datepicker" */ '@/modules/datepicker/index.vue')
  },
];

export default routes;